import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "../assets/locales/en/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
  },
  fallbackLng: "en",
  returnObjects: true,
  debug: true,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
  contextSeparator: "_",
});

export default i18n;
